import { render, staticRenderFns } from "./JoinPointContainer.vue?vue&type=template&id=63fc7d2f&scoped=true&"
import script from "./JoinPointContainer.vue?vue&type=script&lang=js&"
export * from "./JoinPointContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc7d2f",
  null
  
)

export default component.exports